import { Dispatch } from 'redux';
import Echo from 'laravel-echo';

import School from '../../types/School';

import {
  addSchool,
  updateSchool,
  deleteSchool,
} from '../../redux/reducers/SchoolsReducer';

export default function subscribeToSchoolsChannel(
  echo: Echo,
  dispatch: Dispatch,
) {
  echo
    .private('schools')
    .listen('Schools\\SchoolCreated', ({ school }: { school: School }) => {
      dispatch(addSchool(school));
    });

  echo
    .private('schools')
    .listen('Schools\\SchoolUpdated', ({ school }: { school: School }) => {
      dispatch(updateSchool(school));
    });

  echo
    .private('schools')
    .listen('Schools\\SchoolDeleted', ({ id }: { id: number }) => {
      dispatch(deleteSchool(id));
    });
}
